// Copyright 2022-2026 - Hewlett Packard Enterprise Company
/* eslint-disable import/prefer-default-export */

/*
 * When adding code that consumes an LD flag, add the flag and a default value
 * here as well.  This helps ensure that there is no gap during the initial
 * application loading window prior to receiving the flags from LD where the
 * flag is completely unavailable, causing a run time error.
 */

// Add/remove flags that indigo currently consumes in the following object map
export const ldFlagDefaults = {
  P_20220820_9616_ILO_ONLY_FW_UPDATE_PARAMS_JSON: [],
  P_20230606_569_FWU_PROD_IDS_EXCLUDE_JSON: [
    'P59867-B21',
    'P59868-B21',
    'P59869-B21',
    'P59870-B21',
  ],
  P_20241104_51729_FWU_EXCLUDE_MODEL_GEN_JSON: [{}],
  P_20230104_11587_CID_DISPLAY_BOOL: false,
  P_20250515_CREDENTIAL_BASED_SERVERS_OVERRIDE_SUBSCRIPTION_ENFORCEMENT_JSON: [
    'aci1',
  ],
  P_20250715_ANALYTICS_USER_EXCEPTIONS_JSON: ['andromedanewuser@gmail.com'],
  P_20250327_971_LIVE_ENDPOINT_MANUAL_CASE_CREATION_BOOL: false,
  T_20220804_8580_UI_LED_TOGGLE_BOOL: false,
  T_20230119_12538_SERVERS_PAGE_CSV_FILE_EXPORT: false,
  T_20230418_997_ENDPOINTS_FOR_SERVER_HW_AND_PROFILES_BOOL: false,
  T_20230524_8648_SERVER_PROFILES_UI_BOOL: false,
  T_20230627_6458_DOWNGRADE_COMPONETS_UI_BOOL: false,
  T_20230816_7618_ENHANCE_SERVER_HW_INV_REPORT_AGG_BY_DRIVES_BOOL: false,
  T_20230726_10157_RUN_VIEW_FW_COMPLIANCE_REPORT_BOOL: false,
  T_20230726_7582_SERVER_HW_DEVICE_CONTROLLER_REPORT: false,
  P_20231018_20166_NOTIFICATION_BANNER_JSON: {},
  T_20230911_939_TOKEN_BASED_ONBOARDING_PHASE2_BOOL: false,
  T_20240202_28002_APPLIANCE_URI_ID_DISCREPANCY_FIX: false,
  T_20241014_52081_MAP_VIEW_ENHANCEMENTS_UI_BOOL: false,
  T_20240410_30981_AHS_FILE_UPLOAD_UI_BOOL: false,
  T_20240607_250_COMPUTE_OPS_MGMT_SHOW_SCHEDULED_PENDING_JOBS_BOOL: false,
  T_20240810_35187_CONFIGURE_OV_SERVER_LOCATION_SERVER_DETAILS_PAGE: false,
  T_20240828_49289_STABLE_USER_PREFERENCES_API_BOOL: false,
  T_20241113_32914_NEW_APPLIANCE_SETTINGS_BOOL: false,
  T_20250411_57282_SUSTAINABILITY_UI_TRENDING_BETA_LABEL_BOOL: false,
  T_20241114_49238_UI_SHOW_ACTIVE_NOTIFICATIONS_JSON: {},
  T_20241022_49238_UI_CUSTOM_KNOWN_ISSUE_JSON: {},
  T_20240918_44812_COM_VCENTER_INTEG_UI_BOOL: false,
  T_20241009_44568_COHESITY_FWU_CASE_BOOL: false,
  T_20241009_52572_OV_SYNERGY_SERVER_TEMPLATES_UI_BOOL: false,
  T_20241031_3962_COM_ILO_ADV_BOOL: false,
  T_20240910_52081_MAP_VIEW_CUSTOMAPI_BOOL: false,
  T_20241120_4246_AHS_CSV_INVENTORY_BOOL: false,
  T_20250317_4632_AHS_PWR_TMP_SENS_CSV_JSON_BOOL: false,
  T_20241126_3350_DEVICE_SUPPORT_CASES_UI: false,
  T_20240830_35875_WARNING_TO_PREFLIGHT_BOOL: false,
  T_20241218_50462_ES_COMPLIANCE_ROLLUP_BOOL: false,
  T_20241112_35860_SERVER_WARRANTY_STATUS_BOOL: false,
  T_20241210_53281_CHATBOT_SUPPORT_BOOL: false,
  T_20250623_73603_COM_APPROVALPOLICY_PHASE2_UI_BOOL: false,
  T_20250312_18961_CONTEXTUAL_HELP_LEARN_MORE_LINKS_BOOL: false,
  T_20250315_18961_CONTEXTUAL_HELP_SHOW_TOPIC_URL_BOOL: false,
  T_20240505_931_INTEGRATE_GLP_HEADER_BOOL: false,
  T_20250205_61638_LIQUID_COOLING_SECTION_HW_INV_UI_BOOL: false,
  T_20260219_122476_INDIGO_PRESELECT_SAME_WORKSPACE_BOOL: false,
  T_20250129_59794_UI_API_SINGLEHOST: false,
  T_20250526_4857_THIRD_PARTY_SERVER_BETA_UI_BOOL: false,
  T_20250206_60795_SSO_PERMISSIONS_BOOL: false,
  T_20240620_35388_STABLE_APPLIANCE_FIRMWARE: false,
  T_20241204_48023_ILO7_SMS_BOOL: false,
  T20250128_4632_AHS_CSV_JSON_BOOL: false,
  T_20250313_971_MANUAL_CASE_CREATION_BOOL: false,
  T_20250409_663_HARDWARE_ATTESTATION_UI_BOOL: false,
  T_20250529_5228_FW_BASELINES_UI_FORMAT_BOOL: false,
  T_20250515_70102_FWU_USER_CONFIG_PREFLIGHT_CHECKS_BOOL: false,
  T_20250602_70791_ENABLE_UI_DARK_MODE_BOOL: false,
  T_20250915_70791_DARK_MODE_HELP_TEST_BOOL: false,
  T_20250527_2252_ILO_SSO_FORM_POST_BOOL: false,
  T_20251004_65559_SESSION_STORAGE_PAGE_RESTORATION: {
    '/activity': false,
    '/appliances': false,
    '/groups': false,
    '/overview': false,
    '/settings': false,
  },
  T_20250605_55452_UPDATE_GROUPS_DTO_BOOL: false,
  T_20250709_89486_SERVER_HARDWARE_REPORT_NEW_UI_BOOL: false,
  T_20250715_73632_CLEAR_UTIL_ALERT: false,
  T_20250724_62843_COM_CUSTOM_SPP_UI_BOOL: false,
  T_20250729_90010_APPROVAL_V1BETA2_MIGRATION_UI_BOOL: false,
  T_20250812_71009_NOTIFICATION_PREFERENCES_ADMIN: false,
  T_20250728_70342_USB_BOOT_PREFLIGHT_BOOL: false,
  T_20250902_63753_SG_AUTODISCOVER_ONBOARD_SERVERS_UI_BOOL: false,
  T_20250911_133_SERVER_HW_REPORT_NEW_AGGREGATE_BY_UI_BOOL: false,
  T_20250916_3097_LOCATIONS_TAGS_SUPPORT_UI_BOOL: false,
  T_20251024_4989_MANUAL_CASE_INCLUDE_AHS_AND_FILES: false,
  T_20250926_6307_FWU_DATE_CHANGE_UI_BOOL: false,
  T_20251107_101636_DOWNLOAD_FW_BEFORE_UPDATE_SUPPORT_ILO7_UI_BOOL: false,
  T_20251029_3778_SNOW_POWEREVENTS_BOOL: false,
  T_260109_64636_USE_KVM_IMAGE_TYPE_BOOL: false,
  T_20251215_98068_POWER_CONSUMPTION_1HOUR_UI_BOOL: false,
  T_20251124_104628_ANALYZE_MCTP_STATUS_CHECK_BOOL: false,
  T_20260116_6500_UI_SHOW_REGION_SELECTOR_BOOL: false,
  T_20251218_99765_OS_SCHEDULE_CHANGE_BOOL: false,
  T_20250106_98741_SUM_MODERNISATION_CFM_UI_BOOL: false,
  T_20260122_88995_LIME_PLAINTEXT_SEARCH_BOOL: false,
  T_20260123_4528_SET_MAINTENANCE_MODE_UI_BOOL: false,
  T_20260210_98066_TAGS_FILTERS_SUPPORT_UI_BOOL: false,
  T_20260302_125492_HIDE_BETA_BOOL: false,
  T_20260303_6826_GROUP_ADD_SERVER_SEARCH_SORT: false,
};
